import { defineMessages } from 'react-intl';

export default defineMessages({
  headerText: {
    description: 'Activation Modal > Header Text',
    defaultMessage: 'Activate Returns & Exchanges',
    id: '6AKvit',
  },
  reauthenticateStepTitle: {
    description: 'Activation Modal > Reauthenticate Step Title',
    defaultMessage: 'Reauthenticate store',
    id: 'aUu+Ss',
  },
  setCarriersStepTitle: {
    description: 'Activation Modal > Set Carriers Step Title',
    defaultMessage: 'Set return service',
    id: 'o0J9ZK',
  },
  setLocationStepTitle: {
    description: 'Activation Modal > Set Location Step Title',
    defaultMessage: 'Set return location',
    id: '0WUhUh',
  },
  notFound: {
    description: 'Activation Modal > Store Not Found',
    defaultMessage: 'Store not found',
    id: 'Ji5dSN',
  },
  storeLoadError: {
    description: 'Activation Modal > Error Loading Store Message',
    defaultMessage: 'Error',
    id: 'TlrbKP',
  },
  cancel: {
    description: 'Activation Modal > Cancel Button',
    defaultMessage: 'Cancel',
    id: 'K2mwOB',
  },
  backButton: {
    description: 'Activation Modal > Back Button',
    defaultMessage: 'Back',
    id: 'SMulSn',
  },
});
